export default __webpack_public_path__ + "static/radial-700c111fef4422656ff7edd4794b7c87.webp";